import React, { createContext, useReducer, useEffect, useContext} from 'react';
import { fetchReportsData } from '../actions/actionSelectors';
import { CalendarReportsContext } from '../context/CalendarReportsProvider';
import { reportsReducer } from '../actions/reports-reducer';
import { REPORTS_DATA_SUCCESS } from '../actions/actionTypes';

const initialState = { reportDetails: null }

export const ReportsContext = createContext();

export function ReportsProvider(props) {
    const { setIsLoading, errorOrWarningHandler } = useContext(CalendarReportsContext); 
    const [state, dispatch] = useReducer(reportsReducer, initialState);
    const { reportDetails } = state;    

    useEffect(() => { 
        if(props.isLogout) { props.clearSessionData(); }
    }, [ props.isLogout]);   

    useEffect(() => { fetchReportsDataHandler(); }, []);

    const fetchReportsDataHandler = async () => {
        setIsLoading(true); 
        await fetchReportsData()
            .then((data) => {   
                dispatch({
                    type: REPORTS_DATA_SUCCESS,
                    payload: {
                        reportDetails: data                        
                    }
                });               
                setIsLoading(false); 
            })
            .catch((error) => {errorOrWarningHandler(true, "wentwrong", true, "reports"); })
    } 

    const provider = {
        reportDetails      
    };

    return (
        <ReportsContext.Provider value={provider}>
            {props.children}
        </ReportsContext.Provider>
    );
}
